import { FIND_ASSIGNABLE_ASSETS } from '@gripp/shared-logic';
import { AssignmentListGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAssetColumns } from '../../groups/components/useAssetColumns';

export type EditRoutineAssetsListProps = {
  workspaceId: string;
  routineId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const EditRoutineAssetsList = ({
  workspaceId,
  routineId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: EditRoutineAssetsListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => {
    if (assignments && workspaceId) {
      return {
        keyword,
        routineId,
        assignments,
        workspaceId,
      };
    }
    return undefined;
  });
  const columns = useAssetColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({
      keyword,
      routineId,
      assignments,
      workspaceId,
    });
  }, [keyword, routineId, workspaceId]);

  if (!filter) return null;

  return (
    <AssignmentListGrid
      modelName="asset"
      query={FIND_ASSIGNABLE_ASSETS}
      dataPrefix="group.findAssignableAssets"
      columns={columns}
      filter={filter}
      assignments={assignments}
      onAssignmentsChange={updateAssignments}
      maxHeight={maxHeight}
      textEmpty={t('assets.textEmpty')}
    />
  );
};
